module.exports = __webpack_public_path__ + "img/lang_javascript.0154328f.svg";